import * as React from 'react';
import { asField } from 'informedv1';
import DatePicker from 'react-datepicker';
import * as moment from 'moment';

export const DateTime = asField(({ fieldState, fieldApi, onChange = () => { }, onBlur = () => { }, ...props }) => {

    const dateTime = fieldState.value
        ? moment(fieldState.value)
        : null;

    const handleChange = (value) => {
        if (value)
            fieldApi.setValue(value.toISOString(true));
        else {
            fieldApi.setValue(null);
        }

        onChange();
    }

    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        fieldApi.setTouched(true);
        onBlur();
    }

    const handleChangeRaw = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;

        if (!moment(value, props.dateFormat, true).isValid()) {
            fieldApi.setValue(null);
            onChange();
        }
    }

    return (
        <>
            <DatePicker className="form-control" {...props} selected={dateTime} onChangeRaw={handleChangeRaw} onChange={handleChange} onBlur={handleBlur} />

            {fieldState.error ? (
                <span style={{ color: 'red' }}>{fieldState.error}</span>
            ) : null}
            {fieldState.asyncError ? (
                <span style={{ color: 'red' }}>{fieldState.asyncError}</span>
            ) : null}
        </>
    );
});
